import { HttpClient } from 'components/http/HttpClient';
import { ICreateReviewRequest, IReview, IReviewsResponse, IUpdateReviewRequest } from './model/Review';
class ReviewsApi extends HttpClient {
    constructor() {
        super({
            baseURL: process.env.API_SERVER_URL,
            url: '/reviews'
        });
    }

    createReview(request: ICreateReviewRequest, abortSignal?: AbortSignal): Promise<IReview> {
        return this.postRequest<ICreateReviewRequest, IReview>({
            url: '/reviews',
            data: request,
            configs: {
                signal: abortSignal
            }
        });
    }
    updateReview(
        reviewId: string,
        request: IUpdateReviewRequest,
        abortSignal: AbortSignal
    ): Promise<IReview> {
        return this.putRequest<IUpdateReviewRequest, IReview>({
            url: `/reviews/${reviewId}`,
            data: request,
            configs: {
                signal: abortSignal
            }
        });
    }

    getReviews(orderId: number): Promise<IReviewsResponse> {
        return this.getRequest<IReviewsResponse>({
            url: '',
            configs: {
                params: {
                    orderId,
                    sort: 'createdAt'
                }
            }
        });
    }
}

export const reviewsApi = new ReviewsApi();
